export default function getApplication() {
  return process.env.NODE_ENV === 'production'
    ? window.location.hostname.split('.').shift()
    : 'ether';
  // "admin" === super admin
  // "teamtma" === regular admin
  // "ether" === regular admin
  // "register" === registration
}
